
@switch (columnId) {
  @case ('tid') {
    <lib-text-table-column>
      {{ element.tid }}
    </lib-text-table-column>
  }
  @case ('mid') {
    <lib-text-table-column>
      {{ element.mid }}
    </lib-text-table-column>
  }
  @case ('gateway') {
    <lib-text-table-column>
      {{ element.gateway }}
    </lib-text-table-column>
  }
  @case ('feePlan') {
    <lib-text-table-column>
      {{ element.feePlan }}
    </lib-text-table-column>
  }
  @case ('surchargePercent') {
    <lib-text-table-column>
      {{ element.surcharge?.percent | vituPercentage }}
    </lib-text-table-column>
  }
  @case ('deviceSerial') {
    <lib-text-table-column>
      {{ cloverPosConfig?.deviceSerial }}
    </lib-text-table-column>
  }
  @case ('deviceName') {
    <lib-text-table-column>
      {{ cloverPosConfig?.deviceName }}
    </lib-text-table-column>
  }
  @case ('deviceManufacturer') {
    <lib-text-table-column>
      {{ cloverPosConfig?.deviceManufacturer }}
    </lib-text-table-column>
  }
  @case ('deviceModel') {
    <lib-text-table-column>
      {{ cloverPosConfig?.deviceModel }}
    </lib-text-table-column>
  }
  @case ('deviceLocation') {
    <lib-text-table-column>
      {{ cloverPosConfig?.deviceLocation }}
    </lib-text-table-column>
  }
  @case ('status') {
    @if (cloverPosConfig?.status) {
      <lib-status-chip
        class="pos-terminal-statuses"
        [status]="cloverPosConfig?.status">
      </lib-status-chip>
    } @else {
      <lib-text-table-column>
      </lib-text-table-column>
    }
  }
  @default {
  }
}





